import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

class PackagesStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      packages: [],
      loading: false,
      error: null,
      activeStatus: ''
    };
    super('packages', initialState);
  }

  get filteredPackages() {
    if (!this.state.activeStatus) return this.state.packages;
    return this.state.packages.filter(p => p.status === this.state.activeStatus);
  }
}

export default PackagesStore;
